import {
  ChatnewMA,
  ChatnewZyia,
  ChatnewYoli,
  ChatnewDefault,
  ChatnewPartnerCo,
  ActivityMA,
  ActivityZyia,
  ActivityYoli,
  ActivityDefault,
  ActivityPartnerCo,
} from "../assets/icons";

export const REGISTRATION_PARTNER_CO_COLOR = "#DCFD8B";

export const getBrandColor = (client: string | null | undefined): string => {
  if (!client) {
    return "#1593D6";
  }

  switch (client.replace(/\s/g, '')) {
    case "marketamerica": {
      return "#1593D6";
    }
    case "zyiaactive": {
      return "#3e2a52";
    }
    case "beyondslim": {
      return "beyond_slim_color";
    }
    case "Yoli": {
      return "#d49830";
    }
    case "Verb": {
      return "#555555";
    }
    case "Hussle": {
      return "#555555";
    }
    case "tranont": {
      return "rgb(145, 26, 75)";
    }
    case "partner.co": {
      return "#153e39";
    }
    default:
      return "#1593D6";
  }
};

export interface BrandTheme {
  primary: string;
  secondary: string;
  accent: string;
  background: string;
  border: string;
  text: {
    primary: string;
    secondary: string;
    light: string;
  };
}

export const getBrandChatIcon = (client: string | null | undefined) => {
  if (!client) {
    return ChatnewDefault;
  }

  switch (client) {
    case "Market America": {
      return ChatnewMA;
    }
    case "marketamerica": {
      return ChatnewMA;
    }
    case "zyiaactive": {
      return ChatnewZyia;
    }
    case "beyondslim": {
      return ChatnewZyia;
    }
    case "Yoli": {
      return ChatnewYoli;
    }
    case "Verb": {
      return ChatnewDefault;
    }
    case "Hussle": {
      return ChatnewDefault;
    }
    case "partner.co": {
      return ChatnewPartnerCo;
    }
    default: {
      return ChatnewDefault;
    }
  }
};

export const getBrandChatIconInactive = (client: string | null | undefined) => {
  if (!client) {
    return ActivityMA;
  }

  switch (client) {
    case "Market America": {
      return ActivityMA;
    }
    case "marketamerica": {
      return ActivityMA;
    }
    case "zyiaactive": {
      return ActivityZyia;
    }
    case "beyondslim": {
      return ActivityZyia;
    }
    case "Yoli": {
      return ActivityYoli;
    }
    case "Verb": {
      return ActivityDefault;
    }
    case "Hussle": {
      return ActivityDefault;
    }
    case "partner.co": {
      return ActivityPartnerCo;
    }
    default: {
      return ActivityMA;
    }
  }
};

export const getBrandTheme = (client: string | null | undefined): BrandTheme => {
  const theme: BrandTheme = {
    primary: "#1a1a1a",
    secondary: "#666666",
    accent: "#0066cc",
    background: "#ffffff",
    border: "#e5e5e5",
    text: {
      primary: "#1a1a1a",
      secondary: "#666666",
      light: "#999999",
    },
  };

  if (!client) {
    return theme;
  }

  switch (client) {
    case "Market America": {
      return {
        ...theme,
        primary: "#1593D6",
        accent: "#1593D6",
      };
    }
    case "marketamerica": {
      return {
        ...theme,
        primary: "#1593D6",
        accent: "#1593D6",
      };
    }
    case "zyiaactive": {
      return {
        ...theme,
        primary: "#3e2a52",
        accent: "#3e2a52",
      };
    }
    case "beyondslim": {
      return {
        ...theme,
        primary: "#000000",
        accent: "#000000",
      };
    }
    case "Yoli": {
      return {
        ...theme,
        primary: "#d49830",
        accent: "#d49830",
      };
    }
    case "Verb":
    case "Hussle": {
      return {
        ...theme,
        primary: "#1a1a1a",
        accent: "#1a1a1a",
      };
    }
    case "tranont": {
      return {
        ...theme,
        primary: "rgb(145, 26, 75)",
        accent: "#ffffff",
      };
    }
    case "partner.co": {
      return {
        ...theme,
        primary: "#153e39",
        accent: "#000000",
      };
    }
    default: {
      return {
        ...theme,
        primary: "#1a1a1a",
        accent: "#1a1a1a",
      };
    }
  }
};

